export type VideoQualityLabel = 'SD' | 'HD' | 'FHD' | 'QHD' | '4K'

export type InboundQualityLabel = 'excellent' | 'good' | 'fair' | 'poor'

export const getResolutionQualityLabel = (height: number): VideoQualityLabel => {
  if (height >= 2160) return '4K'
  if (height >= 1440) return 'QHD'
  if (height >= 1080) return 'FHD'
  if (height >= 720) return 'HD'
  return 'SD'
}

export const getInboundQualityScore = (packetLossPercent: number, jitterMs: number): number => {
  let score = 100
  score -= Math.min(packetLossPercent * 10, 50)
  score -= Math.min(jitterMs / 5, 20)
  return Math.max(0, Math.min(100, Math.round(score)))
}

export const getInboundQualityLabel = (score: number): InboundQualityLabel => {
  if (score >= 90) return 'excellent'
  if (score >= 70) return 'good'
  if (score >= 50) return 'fair'
  return 'poor'
}

export const formatBitrateKbps = (kbps: number): string => {
  if (kbps >= 1000) return `${(kbps / 1000).toFixed(1)} Mbps`
  return `${Math.round(kbps)} kbps`
}

export const formatPacketLossPercent = (percent: number): string => {
  if (percent < 0.1) return '0'
  if (percent < 10) return percent.toFixed(1)
  return Math.round(percent).toString()
}
